import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Search, Users } from 'lucide-react';
import { api } from '../../api.js';
import { Card, EmptyState, PageHeader, Spinner, Input, Badge } from '../../components/ui.jsx';

export default function IndividualsPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['users-list', search],
    queryFn: () => api.listUsers(search ? { search } : {})
  });

  return (
    <>
      <PageHeader title="Individuals" description="Browse capability data per person." />
      <div className="mb-4 max-w-md relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
        <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name or email" className="pl-9" />
      </div>

      {isLoading ? (
        <div className="min-h-[20vh] grid place-items-center"><Spinner className="w-8 h-8 text-primary-600" /></div>
      ) : !data?.users?.length ? (
        <EmptyState icon={Users} title="No users found" description="Try a different search or invite team members from Setup → Users." />
      ) : (
        <Card padding={false}>
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-wider text-ink-500 border-b border-ink-200">
              <tr>
                <th className="text-left py-3 px-4">Name</th>
                <th className="text-left py-3 px-4">Email</th>
                <th className="text-left py-3 px-4">Status</th>
                <th className="text-left py-3 px-4">Last active</th>
              </tr>
            </thead>
            <tbody>
              {data.users.map(u => (
                <tr key={u.id} className="border-b border-ink-100 hover:bg-ink-50/50">
                  <td className="py-3 px-4">
                    <Link to={`/insights/individuals/${u.id}`} className="font-medium text-ink-900 hover:text-primary-700">{u.full_name}</Link>
                    {u.job_title ? <div className="text-xs text-ink-500">{u.job_title}</div> : null}
                  </td>
                  <td className="py-3 px-4 text-ink-600">{u.email}</td>
                  <td className="py-3 px-4">
                    <Badge variant={u.status === 'active' ? 'green' : u.status === 'invited' ? 'amber' : 'grey'}>{u.status}</Badge>
                  </td>
                  <td className="py-3 px-4 text-ink-500 text-xs">{u.last_login_at ? new Date(u.last_login_at).toLocaleDateString('en-AU') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
